<template>
    <div class="appleApplicationClass">
      <div>
        <HeaderView />
      </div>
      <div>
        <AppleA />
      </div>
      <div>
        <FooterView />
      </div>
    </div>
    </template>
    
    <script>
    import HeaderView from "@/components/HeaderView.vue";
    import FooterView from "@/components/FooterView.vue";
    import AppleA from "@/components/ServicePages/MobileApplicationPage/ApplePage/AppleA.vue";
    
    export default {
      name: "ColorRain",
      components: {
        HeaderView,
        AppleA,
        FooterView,
      },
    };
    </script>
    
    <style scoped>
    
    </style>
      